const NUMBER = /^-?(\d+\.?\d*|\.\d+)$/;

export const valueOfText = (text: string): number | string | null => {
  const compact = text.replace(/\s/g, '').replace(',', '.');
  if (compact === '') return null;
  const value = Number(compact);
  return NUMBER.test(compact) && Number.isFinite(value) ? value : text;
};

const PLAIN = new Intl.NumberFormat('en-US', { useGrouping: false, maximumFractionDigits: 20 });

export const numberText = (value: number): string => {
  return PLAIN.format(value === 0 ? 0 : value);
};

export const textOfValue = (value: unknown): string => {
  if (typeof value === 'number') return Number.isFinite(value) ? numberText(value) : '';
  return typeof value === 'string' ? value : '';
};

export const sameValue = (a: unknown, b: unknown): boolean => {
  return Object.is(a, b) || (a == null && b == null) || (a === 0 && b === 0);
};

export const stepped = (value: number, step: number, direction: 1 | -1): number => {
  const decimals = Math.max(decimalsOf(value), decimalsOf(step));
  return Number((value + direction * step).toFixed(Math.min(decimals, 20)));
};

const decimalsOf = (value: number): number => {
  const [, fraction = ''] = numberText(value).split('.');
  return fraction.length;
};
